<template>
    <div>
        <template v-if="!editMode">
            <div
                class="d-flex align-items-center justify-content-between"
                style="max-width: 200px"
            >
                <div v-for="(link, id) in linkFields" :key="id">
                    <span v-if="getValueFromObject(data, link.path)">
                        <a
                            :href="
                                validateLink(
                                    getValueFromObject(data, link.path)
                                )
                            "
                            target="_blank"
                        >
                            <a-icon
                                :iconClass="'text-dark'"
                                :icon="link.icon"
                            />
                        </a>
                    </span>
                    <span v-else-if="!isShopUser">
                        <a-icon
                            :iconClass="'text-gray'"
                            :icon="link.icon"
                            v-tooltip="
                                'Możesz dodać link do mediów społecznościowych przy edycji sklepu'
                            "
                        />
                    </span>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row m-userStores__socialMediaBox">
                <span class="m-userStores__contactHeader d-lg-none col-12 p-0">Linki do mediów społecznościowych</span>
                <div
                    class="form-groups pt-4 pt-lg-0 m-userStores__socialMediaColumn"
                >
                    <div
                        class="d-flex justify-content-between row"
                        v-for="(link, id) in linkFields"
                        :key="id"
                    >
                        <div class="d-flex align-items-center col-10">
                            <a-icon
                                :icon="link.icon"
                                :iconClass="
                                    isEditModeField(data, link.path, link.name)
                                        ? 'text-primary'
                                        : 'text-dark'
                                "
                                class="mr-2"
                            />
                            <a
                                v-if="
                                    !isEditModeField(data, link.path, link.name)
                                "
                                :href="
                                    validateLink(
                                        getValueFromObject(data, link.path)
                                    )
                                "
                                target="_blank"
                                class="m-userStores__socialMediaLink"
                            >
                                {{ getValueFromObject(data, link.path) }}
                            </a>
                            <the-input
                                v-else
                                :id="`${link.name}`"
                                :label="link.inputPlaceholder"
                                :name="`${link.name}`"
                                :text="getValueFromObject(data, link.path)"
                                type="text"
                                class="w-100"
                                @input="onChange(link.path, $event)"
                            />
                        </div>
                        <div class="col-2 pl-2">
                            <the-btn
                                v-if="
                                    !isEditModeField(data, link.path, link.name)
                                "
                                class="btn-primary btn-outline-custom h-100"
                                icon="Edit"
                                @click.native="editLink(link.name)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            editModeFields: []
        }
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            required: false
        },
        tempData: {
            type: Object,
            required: false
        },
        linkFields: {
            type: Array,
            required: true
        }
    },
    methods: {
        editLink(name) {
            this.editModeFields.push(name)
        },
        getValueFromObject(object, path) {
            return object[path]
        },
        isEditModeField(data, path, name) {
            return (
                !this.getValueFromObject(this.tempData, path) ||
                this.editModeFields.includes(name)
            )
        },
        onChange(path, event) {
            this.data[path] = event
        },
        validateLink(path) {
            return path && !/^https?:\/\//i.test(path) ? 'http://' + path : path
        }
    },
    computed: {
        isShopUser() {
            return this.$store.getters.isShopUser
        }
    }
}
</script>
